import { Component, Input } from '@angular/core';
import { PrimengModule } from '../../primeng.module';
import { MenuItem } from 'primeng/api';
import { BreadcrumbService } from 'src/app/core/service/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  imports: [PrimengModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css'
})
export class BreadcrumbComponent {
  items: MenuItem[] = [];
  home: MenuItem = { icon: 'pi pi-home', routerLink: '/' };

  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbService.breadcrumbs$.subscribe(items => {
      this.items = items;
    });
  }
}
